let prefix = '/api/authenticationFailuresScheduled';

function auth(data) {
    return window.axios.post(prefix, data);
}



export default {
    auth
    
}